export const paramsForSortMenuCompanies = [
  {
    title: "Name:",
    text: "A-Z",
    icon: "",
    orderBy: "nameBrand",
    direction: "ASC",
  },
  {
    title: "Name:",
    text: "Z-A",
    icon: "",
    orderBy: "nameBrand",
    direction: "DESC",
  },
];
export const paramsForSortMenuFunds = [
  {
    title: "Name:",
    text: "A-Z",
    icon: "",
    orderBy: "nameBrand",
    direction: "ASC",
  },
  {
    title: "Name:",
    text: "Z-A",
    icon: "",
    orderBy: "nameBrand",
    direction: "DESC",
  },
];
export const paramsForSortMenuPeople = [
  {
    title: "Name:",
    text: "A-Z",
    icon: "",
    orderBy: "nameFull",
    direction: "ASC",
  },
  {
    title: "Name:",
    text: "Z-A",
    icon: "",
    orderBy: "nameFull",
    direction: "DESC",
  },
];
